var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgArrowRightDefault = function SvgArrowRightDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": true,
    viewBox: "0 0 8 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.194.102.65.617c-.108.136-.108.352 0 .461l4.91 4.908-4.91 4.936c-.108.108-.108.325 0 .461l.543.515a.31.31 0 0 0 .46 0L7.35 6.231a.37.37 0 0 0 0-.462L1.655.102a.31.31 0 0 0-.461 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightDefault);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;